<template>
  <div>
    <div
      class="margin-8 padding-12 bg-white text-grey flex justify-between align-center"
      @click="show = true"
    >
      <span class="text-12">未找到您需要的品牌/车型？点此反馈</span>
      <van-icon name="arrow" size="16" />
    </div>
    <div class="margin-8 padding-12 bg-white">
      <div class="text-16 margin-bottom-8">热门品牌</div>
      <van-grid :column-num="3" :border="false">
        <van-grid-item v-for="item in hotBrandList" :key="item.id" @click="selectBrand(item)">
          <van-image :src="item.logo" width="50" height="50" />
          <span>{{ item.brand_name }}</span>
        </van-grid-item>
      </van-grid>
    </div>
    <van-index-bar :z-index="2">
      <template v-for="(value, name) in brandInfo">
        <van-index-anchor :index="name" :key="name" />
        <template v-for="brand in brandInfo[name]">
          <van-cell :key="brand.id" @click="selectBrand(brand)">
            <template #title>
              <div class="flex align-center">
                <van-image
                  :src="brand.logo"
                  lazy-load
                  width="40"
                  height="40"
                ></van-image>
                <span class="margin-left-4">{{ brand.brand_name }}</span>
              </div>
            </template>
          </van-cell>
        </template>
      </template>
    </van-index-bar>

    <van-popup v-model="show">
      <div class="padding-16" style="width: 80vw">
        <div class="text-center text-16">请输入品牌名称</div>
        <div class="text-center text-grey text-12 margin-tb-16">
          核实后我们尽快为您收录到车型库
        </div>
        <van-form @submit="onSubmit" label-width="60px">
          <van-field
            v-model="form.carBrand"
            label="品牌"
            placeholder="请输入品牌名"
          />
          <van-field
            v-model="form.carModel"
            label="车型"
            placeholder="请输入车型"
          />
          <div style="margin: 16px">
            <van-button
              round
              block
              :loading="submitLoading"
              :disabled="submitDisabled"
              type="primary"
              native-type="submit"
              size="small"
              >提交</van-button
            >
          </div>
        </van-form>
      </div>
    </van-popup>

    <van-popup v-model="showModel" position="right">
      <div class="model padding-12">
        <div v-if="modelInfo.list.length">
          <div class="center-flex">
            <van-image width="100" height="100" :src="modelInfo.logo" />
          </div>
          <van-cell-group>
            <van-cell
              v-for="item in modelInfo.list"
              :key="item.id"
              :title="item.name"
              @click="selectVehicle(item)"
            />
          </van-cell-group>
        </div>
        <van-empty description="暂无车型" v-else />
      </div>
    </van-popup>
  </div>
</template>

<script>
import Vue from 'vue'
import qs from 'qs'
import { handleApp } from '@/utils/handle_app'
import {
  IndexBar,
  IndexAnchor,
  Cell,
  CellGroup,
  Grid,
  GridItem,
  Image,
  Popup,
  Form,
  Field,
  Loading,
  Empty,
  Lazyload
} from 'vant'
import { fetchBrandList, fetchDetaiById, updateModel } from 'api/vehicle'

Vue.use(IndexBar)
  .use(IndexAnchor)
  .use(Cell)
  .use(CellGroup)
  .use(Grid)
  .use(GridItem)
  .use(Image)
  .use(Popup)
  .use(Form)
  .use(Field)
  .use(Loading)
  .use(Empty)
  .use(Lazyload)

const imgUrl =
  'http://dyyy-static.oss-cn-shenzhen.aliyuncs.com/App-server/images/car_brand/'
export default {
  data () {
    return {
      form: {},
      brandInfo: {},
      hotBrandList: [],
      show: false,
      showModel: false,
      loading: false,
      modelInfo: {
        logo: '',
        list: []
      },
      selectId: 0,
      submitLoading: false,
      submitDisabled: false
    }
  },
  created () {
    this.getList()
  },
  methods: {
    async getList () {
      const res = await fetchBrandList()
      const hotBrandListName = [
        '大众',
        '本田',
        '丰田',
        '比亚迪',
        '吉利',
        '广汽',
        '长安',
        '日产'
      ]
      const brandInfo = {}
      const hotBrandList = []
      res.brandList.forEach((item) => {
        item.logo = imgUrl + item.brand_logo
        if (!Reflect.has(brandInfo, item.first_letter)) {
          Reflect.set(brandInfo, item.first_letter, [item])
        } else {
          brandInfo[item.first_letter].push(item)
        }
        if (
          hotBrandListName.includes(item.brand_name) &&
          !hotBrandList.includes(item.brand_name)
        ) {
          hotBrandList.push(item)
        }
      })
      this.hotBrandList = hotBrandList
      this.brandInfo = brandInfo
    },
    async selectBrand (brand) {
      if (this.selectId !== brand.id) {
        this.selectId = brand.id
        fetchDetaiById({ brandId: brand.id })
          .then((res) => {
            this.modelInfo = {
              logo: imgUrl + brand.brand_logo,
              list: res
            }
          })
          .finally(() => {
            this.showModel = true
          })
      } else {
        this.showModel = true
      }
    },
    onSubmit () {
      if (!this.form.carBrand) {
        this.$toast('品牌不能为空')
        return
      }
      if (!this.form.carModel) {
        this.$toast('车型不能为空')
        return
      }
      this.submitLoading = true
      this.submitDisabled = true
      updateModel(qs.stringify(this.form)).then(() => {
        this.form = {}
        this.show = false
        this.$toast.success('提交成功')
      }).finally(() => {
        this.submitLoading = false
        this.submitDisabled = false
      })
    },

    selectVehicle (item) {
      const { id, name, sname, levelName } = item
      handleApp('vehicle', {
        id,
        name,
        sname,
        levelName
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.model {
  height: 100vh;
  width: 60vw;
  overflow: auto;
  position: relative;
}
</style>
